function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.3755736mm",
    height: "6.7263718mm",
    viewBox: "0 0 5.3755736 6.7263718",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.322196,-144.33753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.560314,37.259349)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.98108
    },
    transform: "matrix(0.67110046,0,0,0.67069462,-14.300391,52.953365)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.394782,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 74.246209,459.62846 -23.890375,-41.37934 47.780748,0 z",
    transform: "matrix(-0.1662689,0,0,-0.24007608,-17.829395,191.09282)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.5ea822925c81ad0a97d864e37f8301e7.svg";
export { ForwardRef as ReactComponent };